<template>
  <div class="section section_big-padding-top">
    <div class="max-width">
      <div class="features">

        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">Features for</div>
          <h2 class="section__title">E-Commerce Success</h2>
          <div class="section__text">Explore the features built to enhance user experience, simplify shopping, and maximize store performance.</div>
        </div>

        <div class="features__list">
          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">This Theme <br>is Great for</div>
            </div>
            <div class="features__column">
              <strong>Diverse store volumes</strong>
              Designed for stores that process both small and large number of transactions in a given period.
            </div>
            <div class="features__column">
              <strong>Physical stores</strong>
              Designed for stores that do in-person selling.
            </div>
            <div class="features__column">
              <strong>Visual storytelling</strong>
              Designed to showcase images to support visual brand storytelling.
            </div>
          </div>

          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">Cart and Checkout</div>
            </div>
            <div class="features__column">
              <ul>
                <li>Cart notes</li>
                <li>Sticky cart</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>In-store pickups</li>
                <li>Cart Drawer</li>
                <li>Slide-out cart</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>Quick buy</li>
                <li>Quick view</li>
              </ul>
            </div>
          </div>

          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">Marketing and Conversion</div>
            </div>
            <div class="features__column">
              <ul>
                <li>Age verifier</li>
                <li>Blogs</li>
                <li>Size chart</li>
                <li>Cross-selling</li>
                <li>Customizable contact form</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>Promo banners</li>
                <li>Promo popups</li>
                <li>Recommended products</li>
                <li>Product badges</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>EU translations (EN, FR, IT, DE, ES)</li>
                <li>FAQ page</li>
                <li>In-menu promos</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .features {
    &__list {
      display:flex;
      flex-direction:column;
      gap:1.25rem;
    }

    &__item {
      padding:2rem;
      background:var(--color-gray-light);
      border-radius:24px;
      gap:2rem;
      display:flex;

      @include md {
        flex-wrap:wrap;
        grid-row-gap:1rem;
      }

      @include xs {
        display:grid;
        grid-template-columns:repeat(2,1fr);
      }
    }

    &__column {
      flex:1;
      font-size:.875rem;

      @include md {
        &:first-child {
          flex:none;
          min-width:100%;
        }
      }

      @include xs {
        &:first-child {
          grid-column:1/-1;
        }
      }

      strong {
        display:block;
        font-size:1rem;
        font-weight:600;
        margin:0 0 .25rem;
      }

      ul {
        list-style:disc;
        margin:0 0 0 1.25rem;
        padding:0;
        display:flex;
        flex-direction:column;
        gap:2px;
      }
    }

    &__label {
      font-size:1.25rem;
      font-weight:900;
      max-width:240px;
      letter-spacing: -0.01em;
      line-height: 1.2;
      text-transform: uppercase;
    }
  }
</style>
<script setup>
</script>
